import React, { JSX } from "react";
import Cover from "./Cover";
import Description from "./Description";
import WorkerCard from "./WorkerCard";
import Service from "./Service";
import ContactInfo from "./ContactInfo";
import CompanyIframe from "./CompanyIframe";

export default function WelcomePage(): JSX.Element {
    return (
        <>
            <Cover/>
            <Description/>
            <section className="bg-light py-5" id="members">
                <div className="container text-center">
                    <h2 className="mb-5">Nasz zespół</h2>
                    <div className="row g-4 justify-content-center">
                        <WorkerCard
                            imgSrc={"/maks.jpeg"}
                            imgAlt={"Maksym"}
                            workerName={"Maksym"}
                            workerPosition={"Administrator"}
                            shortDescription={<p>Maksym — <strong>administrator</strong> i <strong>doradca</strong>,
                                serce naszego warsztatu</p>}
                            workerPositionDescription={<p>Maksym to osoba, która dba o sprawne funkcjonowanie całego
                                warsztatu.</p>}
                            workerCharacteristics={
                                <ul>
                                    <li>
                                        <strong>Precyzja</strong> i <strong>dbałość</strong> o każdy detal
                                    </li>
                                    <li>
                                        <strong>Rzetelność</strong> – uczciwe podejście do klienta
                                    </li>
                                    <li>
                                        <strong>Szeroka wiedza techniczna</strong>
                                    </li>
                                    <li>
                                        <strong>Empatia</strong> – tłumaczy zrozumiale
                                    </li>
                                </ul>
                            }
                        />
                        <WorkerCard
                            imgSrc={"/serg.jpg"}
                            imgAlt={"Serhii"}
                            workerName={"Serhii"}
                            workerPosition={"Mechanik"}
                            shortDescription={
                                <p>Serhii — <strong>główny</strong> mechanik, <strong>mistrz</strong> precyzji i doświadczenia</p>
                            }
                            workerPositionDescription={
                                <p>
                                    To osoba, dla której samochody nie mają tajemnic,
                                    a jego praca jak muzyka — leczy rany waszego auta.
                                </p>
                            }
                            workerCharacteristics={
                                <ul>
                                    <li>
                                        <strong>Szybko diagnozuje</strong> usterki
                                    </li>
                                    <li>
                                        <strong>Naprawia</strong> szeroki zakres układów
                                    </li>
                                    <li>
                                        <strong>Doradza</strong> klientom jak dbać o auto
                                    </li>
                                    <li>
                                        <strong>Dotrzymuje terminów</strong>
                                    </li>
                                </ul>
                            }
                        />
                    </div>
                </div>
            </section>
            <section className="py-5" id="services">
                <div className="container text-center">
                    <h2 className="mb-5">Jakie usługi oferujemy</h2>
                    <div className="row g-4">
                        <Service
                            serviceName={"Diagnostyka"}
                            services={
                                [
                                    "Diagnostyka komputerowa",
                                    "Diagnostyka mechaniczna",
                                    "Ustalenie genezy usterki oraz jej usunięcie",
                                ]
                            }
                        />
                        <Service
                            serviceName={"Serwis"}
                            services={
                                [
                                    "Układ zapłonowy / żarowy",
                                    "Układ napędowy",
                                    "Układ hamulcowy",
                                    "Układ kierowniczy",
                                    "Układ chłodzenia",
                                    "Układ wydechowy / dolotowy",
                                    "Ogrzewanie / Wentylacja / Klimatyzacja",
                                    "Zawieszenie / Koła",
                                    "Amortyzacja pojazdu"
                                ]
                            }
                        />
                        <Service
                            serviceName={"Naprawy mechaniczne"}
                            services={
                                [
                                    "Naprawa skrzyń biegów (manual / automat: DSG, ZF, AISIN)",
                                    "Czyszczenie filtrów DPF",
                                    "Układ zapłonowy / żarowy",
                                    "Układ napędowy",
                                    "Układ hamulcowy",
                                    "Układ kierowniczy",
                                    "Układ chłodzenia",
                                    "Układ wydechowy / dolotowy",
                                    "Ogrzewanie / Wentylacja / Klimatyzacja",
                                    "Zawieszenie / Koła",
                                    "Amortyzacja pojazdu"
                                ]
                            }
                        />
                        <Service
                            serviceName={"Usługi Dodatkowe"}
                            services={
                                [
                                    "Usługa lawety / transport pojazdu",
                                    "Doradztwo przy zakupie auta (od wyboru aż po wyjazdy sprawdzające)",
                                    "Zakup oraz sprowadzenie samochodów z europejskich aukcji samochodowych"
                                ]
                            }
                        />
                    </div>
                </div>
            </section>
            <section className="bg-dark text-white py-5" id="contact">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <ContactInfo/>
                        <CompanyIframe/>
                    </div>
                </div>
            </section>
            <footer className="py-3">
                <div className="container text-center">
                    <p className="mb-0">© 2025 M&S AS GARAGE. Wszystkie prawa są zastrzeżone.</p>
                </div>
            </footer>
        </>
    );
}